import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import useStyles from "./style";




export function DetailPanel({ children }) {
  const classes = useStyles();
  return (
    React.createElement(Box, { className: classes.detailPanel,}
      , React.createElement(Grid, { container: true,}
        , children
      )
    )
  );
}

export function DetailPaneList({ children, label }) {
  const classes = useStyles();
  return (
    React.createElement(Grid, { item: true, xs: 6,}
      , React.createElement(Typography, { className: classes.detailPanelLabel, variant: "subtitle2",}, label)
      , React.createElement(Grid, { container: true,}
        , children
      )
    )
  );
}

export function DetailPanelItem({ title, value }) {
  const classes = useStyles();
  return (
    React.createElement(React.Fragment, null
      , React.createElement(Grid, { item: true, xs: 6,}, React.createElement(Typography, { className: classes.detailPanelTitle, variant: "subtitle2", color: "textSecondary",}, title))
      , React.createElement(Grid, { item: true, xs: 6,}, React.createElement(Typography, { className: classes.detailPanelValue, variant: "subtitle2",}, value))
    )
  );
}